import React from 'react'
import { Button, Box, Heading, Icon, HStack, Stack, Text, VStack } from "@chakra-ui/react";
import { NavLink } from "react-router";
import { CheckIcon } from '@chakra-ui/icons'
import { useBreadcrumbs } from '../../contexts/BreadcrumbProvider';

export const ContentCard = ({ icon, title, description, features, buttonText, path }) => {
    const { addBreadcrumb } = useBreadcrumbs();
    return (
        <VStack
            borderWidth="1px"
            borderRadius="lg"
            p={6}
            spacing={4}
            align="stretch"
            justifyContent="space-between"
            width="full"
            boxShadow="md"
            _hover={{ boxShadow: "lg" }}
        >
            <Box>
                <Box width="100%">
                    <Icon as={icon} boxSize={8} color="blue.500" />
                </Box>
                <Heading size="md" mb={2}>{title}</Heading>
                <Text textAlign="center" mb={2} color="gray.600">{description}</Text>
                <Stack spacing={2} align="start">
                    {features.map((feature, index) => (
                        <HStack key={index} align="start" spacing={2}>
                            <Icon as={CheckIcon} color="green.500" mt={1} />
                            <Text textAlign="left" color="gray.600">{feature}</Text>
                        </HStack>
                    ))}
                </Stack>
            </Box>
            <NavLink to={path} onClick={() => addBreadcrumb(title, path, true)} end>
                <Button colorScheme="blue" width="full">
                    {buttonText}
                </Button>
            </NavLink>
        </VStack>
    );
};